import React, { useEffect, useState } from 'react';
import { DrawerList } from './DrawerList';
import { useTheme } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import medicalWISDOM from '../../images/arogyaLogo.png';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useAppDispatch } from 'reduxStore/hooks';
import { toggleAppBarLoading } from 'reduxStore/appLoader/toggleAppBarLoadingSlice';

const drawerWidth = 240;

interface Props {
  drawerState: boolean;
  updateDrawerState: (value: boolean) => void;
  window?: () => Window;
}

export default function ResponsiveDrawer(props: Props) {
  const Token = localStorage.getItem('access');
  const dispatch = useAppDispatch();
  const { window } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const handleListItemClick = (
    _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const navigate = useNavigate();
  const handleLogout = () => {
    dispatch(toggleAppBarLoading(true));
    localStorage.clear();
    dispatch(toggleAppBarLoading(false));
    navigate('/');
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  useEffect(() => {
    setIsDrawerOpen(props.drawerState);
  }, [props.drawerState]);

  const drawer = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Toolbar />

      {/* Scrollable content area */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        <List component='nav' aria-label='main mailbox folders'>
          {DrawerList.slice(0, 1).map((item) => {
            return (
              <ListItem component={Link} to={item.path} key={item.name} disablePadding>
                <ListItemButton onClick={(event) => handleListItemClick(event, 0)}>
                  {!fullScreen && <ListItemIcon>{item.icon}</ListItemIcon>}
                  {fullScreen ? (
                    <img alt='' src={medicalWISDOM} width='50%' />
                  ) : (
                    <Typography
                      variant='body1'
                      fontSize={14}
                      style={{
                        textTransform: 'none',
                        textDecoration: 'none',
                        color: '#1a5f23',
                      }}
                    >
                      {item.name}
                    </Typography>
                  )}
                </ListItemButton>
              </ListItem>
            );
          })}
          <Divider />
          {DrawerList.slice(1, -1).map((item, index) => {
            return (
              <ListItem key={item.name} disablePadding>
                <ListItemButton
                  selected={selectedIndex === index}
                  onClick={(event) => handleListItemClick(event, -1)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography
                      variant='body1'
                      fontSize={14}
                      style={{
                        textTransform: 'none',
                        textDecoration: 'none',
                        color: '#1a5f23',
                      }}
                    >
                      {item.name}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>

      {/* Fixed logout section at bottom */}
      <Box>
        <Divider />
        <List>
          {DrawerList.slice(-1).map((item) => {
            return (
              <ListItem key={item.name} disablePadding>
                <ListItemButton onClick={() => handleLogout()}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText>
                    <Typography
                      variant='body1'
                      fontSize={14}
                      style={{
                        textTransform: 'none',
                        textDecoration: 'none',
                        color: '#1a5f23',
                      }}
                    >
                      {item.name}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      {Token && (
        <Box
          component='nav'
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label='mailbox folders'
        >
          <Drawer
            container={container}
            variant='temporary'
            anchor='left'
            open={isDrawerOpen}
            onClose={() => {
              setIsDrawerOpen(false);
              props.updateDrawerState(false);
            }}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant='permanent'
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
      )}
    </>
  );
}
